import { connectRouter, RouterState } from 'connected-react-router';
import history from './history';
import { LoopReducerWithDefinedState } from 'redux-loop';

// requires default action handling, but not our problem here.
export default connectRouter(history) as LoopReducerWithDefinedState<RouterState>;
